module.exports = __webpack_public_path__ + "img/logo.c3779b48.svg";